import {main, TypeMap} from '../base-image';

main(TypeMap, {animationStart: 8, animationStop: 16});
